import React from "react";
import { StateContext, actions } from "../state/index";
import { ERROR_TYPES } from "../utils/enums";
import Modal from "./library/Modal";
import { logUiError } from "../utils/logging";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // TODO log this to loggly, including the app state
    // eslint-disable-next-line no-empty-pattern
    const [applicationState, dispatch] = this.context;

    console.error(error, info)

    const errorType = ERROR_TYPES.UI_ERRORS.UNCAUGHT_EXCEPTION;

    dispatch(actions.modals.showUiErrorModal(applicationState.configuration, {
      errorType,
      contentProps: {
        showFaqLink: false,
        logData: {
          error: {
            name: error.name,
            message: error.message,
            error,
            info,
          }
        }
      }
    }));

    logUiError(errorType, applicationState);
  }

  render() {
    return !this.state.hasError ? this.props.children : <Modal/>;
  }
}

ErrorBoundary.contextType = StateContext;

export default ErrorBoundary;
